import {
  CarrierSurchargesOverTimeRequestSchema,
  CarrierSurchargesOverTimeResponseSchema,
} from "@redotech/redo-fulfillment-common/metrics";

export const getCarrierSurchargesOverTime = {
  name: "getCarrierSurchargesOverTime" as const,
  input: CarrierSurchargesOverTimeRequestSchema,
  output: CarrierSurchargesOverTimeResponseSchema,
};
